import 'material-design-icons-iconfont/dist/material-design-icons.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import pt from 'vuetify/es5/locale/pt';

import moment from 'moment';
import momentTimezone from 'moment-timezone';
import Icon from '../components/Icon';
import '@fortawesome/fontawesome-free/css/all.css'

Vue.use(Vuetify);

function getUserTimeZone() {
    const data_user = localStorage.getItem('user-data');
    const timeZone = JSON.parse(data_user).time_zone_name;
    return timeZone
}
export default new Vuetify({
    icons: {
        iconfont: 'md',
        iconfont: 'fa',
    },
    theme: {
        dark: false,
        themes: {
            light: {
                primary: '#93291E',
                secondary: '#02A554',
                accent: '#82B1FF',
                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FFC107',
                yellow: '#FFFDE3',
                gray: '#6F6F6F',
                lightGray: '#F7F7F7',
                labelGray: '#AFAFAF',
                white: '#ffffff',
                black: '#000000',
                darkGray: '#717171',
                lightGreen: '#E3FFE3',
                lightBlue: '#fbfbff',
            },
        },
        options: {
            customProperties: true,
        },
    },
    lang: {
        locales: { pt },
        current: 'pt',
    },
});

Vue.filter('formatDate', (value = '') => {
    if (value) {
        const timeZone = getUserTimeZone();
        return moment(value).tz(timeZone).format('DD/MM/YYYY');
    }
});

Vue.filter('formatDateTime', (value = '') => {
    if (value) {
        const timeZone = getUserTimeZone();
        return moment(value).tz(timeZone).format('DD/MM/YYYY HH:mm');
    }
});

Vue.filter('formatDateTZ', (date, time) => {
    if (!time) return '';
    time = time.toString();
    const timeZone = getUserTimeZone();
    return momentTimezone.utc(`${date} ${time}`, 'HH:mm:ss').tz(timeZone).format('HH:mm:ss');
});

Vue.filter('formatHourTZ', (date, time) => {
    if (!time) return '';
    time = time.toString();
    const timeZone = getUserTimeZone();
    return momentTimezone.utc(`${date} ${time}`, 'HH:mm:ss').tz(timeZone).format('HH:mm:ss');
});

Vue.filter('slugify', value => {
    value = value.replace(/^\s+|\s+$/g, ''); // trim
    value = value.toLowerCase();

    // remove accents, swap ñ for n, etc
    const from = 'ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;';
    const to = 'aaaaaeeeeeiiiiooooouuuunc------';
    for (let i = 0, l = from.length; i < l; i++) {
        value = value.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    value = value.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes

    return value;
});
